// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2LEU4","icon":"SortAdornment_icon__2g2Kl","up":"SortAdornment_up__31gWZ","down":"SortAdornment_down__1PLN4","active":"SortAdornment_active__2TgJN"};